

























































































































import Vue from "vue";
import moment from "moment";
import { RootState } from "@/store";
import { mapState } from "vuex";

import { TransactionTypeEnum, transactionTypeEnumLabel } from "@/model/data/enums/TransactionTypeEnum";
import DateTimeRangePicker from "@/components/DateTimeRangePicker.vue";
import { TransactionSubtypeEnum, transactionSubtypeEnumLabel } from "@/model/data/enums/TransactionSubtypeEnum";

export default Vue.extend({
    data() {
        return {
            dateFilterTypes: [
                {
                    text: this.$t("common.dateTime"),
                    value: 0,
                },
                {
                    text: this.$t("common.accounting_date"),
                    value: 1,
                },
            ],
        };
    },
    props: {
        value: {},
    },
    components: {
        DateTimeRangePicker,
    },
    computed: {
        ...mapState({
            startupData: (state: RootState) => state.application.startupData,
        }),
        filter: {
            get: function () {
                let res;
                if (this.value) res = this.value;
                else res = [];
                return res;
            },
            set: function (newValue) {
                if (newValue) {
                    this.$emit("input", newValue);
                } else {
                    this.$emit("input", null);
                }
            },
        },
        availableTransactionTypes() {
            let availableTransactionTypes = [];
            availableTransactionTypes = Object.keys(TransactionTypeEnum)
                .filter((key) => !isNaN(Number(TransactionTypeEnum[key])) && Number(TransactionTypeEnum[key]) >= 0)
                .map((c) => {
                    return {
                        value: TransactionTypeEnum[c],
                        text: this.$t(transactionTypeEnumLabel(TransactionTypeEnum[c])),
                    };
                });
            if (this.startupData && this.startupData.enabledTransactionsSubtypes && this.startupData.enabledTransactionsSubtypes.length) {
                let availableTransactionSubtypes = Object.keys(TransactionSubtypeEnum)
                    .filter(
                        (key) =>
                            !isNaN(Number(TransactionSubtypeEnum[key])) &&
                            Number(TransactionSubtypeEnum[key]) >= 0 &&
                            this.startupData.enabledTransactionsSubtypes.includes(Number(TransactionSubtypeEnum[key]))
                    )
                    .map((c) => {
                        return {
                            value: TransactionSubtypeEnum[c] + 1000,
                            text: this.$t(transactionSubtypeEnumLabel(TransactionSubtypeEnum[c])),
                        };
                    });
                availableTransactionTypes = availableTransactionTypes.concat(availableTransactionSubtypes);
            }
            availableTransactionTypes.sort((a, b) => a.text.localeCompare(b.text));
            return availableTransactionTypes;
        },
        canSubmit() {
            return this.warningMessages.length == 0;
        },
        warningMessages() {
            let res = [];
            if (this.filter.serialNumber && moment(this.filter.endDate).diff(this.filter.startDate, "days") > 3) {
                res.push(this.$t("cash_report.warning_messages.max_days_dates_range_is", [3]));
            }
            if ((this.filter.startingTransactionId && !this.filter.endingTransactionId) || (!this.filter.startingTransactionId && this.filter.endingTransactionId)) {
                res.push(this.$t("cash_report.warning_messages.transactionIds"));
            }
            if (
                (this.filter.startingTransactionId && !/^\d+$/.test(this.filter.startingTransactionId)) ||
                (this.filter.endingTransactionId && !/^\d+$/.test(this.filter.endingTransactionId))
            ) {
                res.push(this.$t("cash_report.warning_messages.transactionIdsInteger"));
            }
            if (
                this.filter.startingTransactionId &&
                /^\d+$/.test(this.filter.startingTransactionId) &&
                this.filter.endingTransactionId &&
                /^\d+$/.test(this.filter.endingTransactionId) &&
                Number.parseInt(this.filter.startingTransactionId) > Number.parseInt(this.filter.endingTransactionId)
            ) {
                res.push(this.$t("cash_report.warning_messages.transactionIdsGreater"));
            }

            return res;
        },
    },
    methods: {
        handleInput(value) {
            this.$emit("input", value);
        },
    },
});
